import type { FC } from "react";
import React from "react";
import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

// Legacy icon not included in current MUI version
// svg sourced from https://materialui.co/icon/polymer

const IconSource = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z" />
  </svg>
);

const PolymerIcon: FC<SvgIconProps> = (...props) => (
  // Note: props are not of type array
  // eslint-disable-next-line @typescript-eslint/no-misused-spread
  <SvgIcon {...props} component={IconSource} />
);

export default PolymerIcon;
